import { StorageWrapper } from '../../../shared/scripts/StorageWrapper.ts';
import { MobileDeviceUtils } from '../../../shared/scripts/MobileDeviceUtils.ts';
import { MobileWebviewCommunicationActions } from '@colonist/mobile';
import { UIMMobileWebviewCommunication } from '../ui_mobile_communication/UIMMobileWebviewCommunication.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { clientI18n } from '../../../shared/scripts/ClientI18n.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { uiManager } from '../EntryMobile.ts';
import { UIDeviceController } from '../../../shared/scripts/ui_html/UIDeviceController.ts';
import { AccessLevel } from '@colonist/types';
export class UIMDeviceHandler {
    static updateUIFromStatusBarHeight(statusBarHeight, safeAreaInsetBottom) {
        const root = document.querySelector(':root');
        root === null || root === void 0 ? void 0 : root.style.setProperty('--status-bar-height', `${statusBarHeight}px`);
        root === null || root === void 0 ? void 0 : root.style.setProperty('--safe-area-inset-bottom', `${Number(safeAreaInsetBottom) / 2}px`);
        StorageWrapper.setStatusBarHeight(statusBarHeight);
        StorageWrapper.setSafeAreaInsetBottom(safeAreaInsetBottom);
    }
    static initSavedInfoFromDevice() {
        const defaultMobileWebBrowserStatusBarHeight = 8;
        const statusBarHeight = UIDeviceController.isUserOnMobileWebBrowser() ? defaultMobileWebBrowserStatusBarHeight : MobileDeviceUtils.getStatusBarHeight();
        const safeAreaInsetBottom = MobileDeviceUtils.getSafeAreaInsetBottom();
        const defaultStatusBarHeight = 56;
        const defaultSafeAreaInsetBottom = 0;
        UIMDeviceHandler.updateUIFromStatusBarHeight(statusBarHeight !== null && statusBarHeight !== void 0 ? statusBarHeight : defaultStatusBarHeight, safeAreaInsetBottom !== null && safeAreaInsetBottom !== void 0 ? safeAreaInsetBottom : defaultSafeAreaInsetBottom);
    }
    static requestNotificationPermission() {
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.RequestNotificationPermission);
    }
    static requestReview() {
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.RequestReview);
    }
    static showNotification(text) {
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTextNotification, clientI18n.t(text.key, text.options));
    }
    static configureSafeArea() {
        const shouldShowSafeArea = UIUtilsEjsVariables.shouldDisplayNewMobileGameUI ? false : true;
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, shouldShowSafeArea);
    }
    static getBuildNumber() {
        return MobileDeviceUtils.getBuildNumber();
    }
    static getPlatform() {
        return MobileDeviceUtils.getPlatform();
    }
    static sendShareLink(link, title = 'Colonist Room') {
        var _UIMDeviceHandler_getBuildNumber;
        const buildNumber = (_UIMDeviceHandler_getBuildNumber = UIMDeviceHandler.getBuildNumber()) !== null && _UIMDeviceHandler_getBuildNumber !== void 0 ? _UIMDeviceHandler_getBuildNumber : 0;
        const isNewBuild = buildNumber > 160;
        const linkData = isNewBuild ? {
            message: '',
            title: title,
            url: link
        } : link;
        if (UIDeviceController.isUserOnMobileWebBrowser()) {
            void navigator.share({
                title: link,
                url: link
            });
            return;
        }
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShareLink, linkData);
    }
    static sendEventsOnAppLoad() {
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.LobbyLoaded);
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, false);
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowSplashScreen, false);
        const shouldSwitchToLandscape = UIUtilsEjsVariables.isUserOnTabletApp;
        var _UIMDeviceHandler_getBuildNumber;
        const currentBuildNumber = (_UIMDeviceHandler_getBuildNumber = UIMDeviceHandler.getBuildNumber()) !== null && _UIMDeviceHandler_getBuildNumber !== void 0 ? _UIMDeviceHandler_getBuildNumber : 0;
        const isNewBuild = currentBuildNumber > 110;
        UIMMobileWebviewCommunication.sendPayloadToMobile(shouldSwitchToLandscape && isNewBuild ? MobileWebviewCommunicationActions.OrientationLandscape : MobileWebviewCommunicationActions.OrientationPortrait);
    }
    static sendUserIdForNotifications() {
        var _ClientUserState_userState;
        var _UIMDeviceHandler_getBuildNumber;
        const currentBuildNumber = (_UIMDeviceHandler_getBuildNumber = UIMDeviceHandler.getBuildNumber()) !== null && _UIMDeviceHandler_getBuildNumber !== void 0 ? _UIMDeviceHandler_getBuildNumber : 0;
        const doesSupportNotifications = currentBuildNumber >= 180;
        if (!doesSupportNotifications) return;
        const userId = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.id;
        if (!userId) return;
        StorageWrapper.setNotificationUserId(userId);
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.NotificationSetExternalUserId, userId);
    }
    static shouldEnableNativePaymentsOnMobile() {
        var _ClientUserState_userState;
        if (!UIMDeviceHandler.isNativePaymentEnabledForCurrentPlatform()) return false;
        const isExternalUser = ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.accessLevel) == AccessLevel.User;
        if (UIUtilsEjsVariables.shouldDisableIAPForExternalUsersOnMobile && isExternalUser) return false;
        var _UIMDeviceHandler_getBuildNumber;
        const buildNumber = (_UIMDeviceHandler_getBuildNumber = UIMDeviceHandler.getBuildNumber()) !== null && _UIMDeviceHandler_getBuildNumber !== void 0 ? _UIMDeviceHandler_getBuildNumber : 0;
        const buildWhereIAPIsSupported = 250;
        return buildNumber >= buildWhereIAPIsSupported;
    }
    static isNativePaymentEnabledForCurrentPlatform() {
        if (UIDeviceController.isUserOnIOSApp()) return UIUtilsEjsVariables.shouldEnableNativeIOSPaymentsOnMobile;
        if (UIDeviceController.isUserOnAndroidApp()) return UIUtilsEjsVariables.shouldEnableNativeAndroidPaymentsOnMobile;
        return false;
    }
    static async pauseForKeyboardToClose() {
        const isKeyboardOpen = window.innerHeight < UIMDeviceHandler.KEYBOARD_HEIGHT_THRESHOLD;
        if (!isKeyboardOpen) return false;
        const shouldDelayLeaveRoom = uiManager.createRoomController.isCreateRoomButNotAHost();
        if (shouldDelayLeaveRoom) await new Promise((resolve)=>setTimeout(resolve, 1000));
        return shouldDelayLeaveRoom;
    }
}
UIMDeviceHandler.KEYBOARD_HEIGHT_THRESHOLD = 550;
